import React, { Suspense, lazy } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from "./Login";
import Loader from "./components/Loader";
import Logout from "./Logout";

const Layout = lazy(() => import("./Layout"));

const App = () => {
  const router = createBrowserRouter(
    [
      { path: "/", element: <Layout /> },
      { path: "/login", element: <Login /> },
      { path: "/logout", element: <Logout /> },
    ]
    // {
    //   basename: "/V2N-NIP-Transaction-Portal",
    // }
  );

  return (
    <Suspense fallback={<Loader />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default App;
